export function capitalize(){var string=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';return string.charAt(0).toUpperCase()+string.slice(1);}